import React from 'react'
import { styled } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { InputLabel } from '@mui/material';

const options = [
    "Today",
    "Yesterday",
    "Last 7 days",
    "Last 30 days",
    "This week",
    "Last week",
    "This month",
    "Last month",
    "Year-to-date",
    "Last year",
];


const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: 8,
        marginTop: "5px",
        minWidth: "129px",
        color:
            theme.palette.mode === "light"
                ? "rgb(55, 65, 81)"
                : theme.palette.grey[300],
        boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
        "& .MuiMenu-list": {
            padding: "11px 5px !important",
        },
        "& .MuiMenuItem-root": {
            fontWeight: "500",
            fontSize: "14px",
            color: "#7D7D7D",
            padding: "1px 3px",
            borderRadius: "5px",
            marginBottom: "3px",
            "&.Mui-selected": {
                background: "#F3F3F3",
            },
            "&:hover": {
                color: "#4b4b4b",
                background: "#F3F3F3",
            },
            "&:active": {
                background: "#F3F3F3",
                borderRadius: "5px",
            },
        },
    },
}));

const Label = styled(InputLabel)`
    color: #111AE9;
    font-size: 14px;
    font-weight: 600;
    text-transform: capitalize;
    line-height: 1.5;
    margin: 0 0 0 5px;
    cursor: pointer;
`

export const AllTimeMenuQCApprove = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <>
            <Label onClick={handleClick}>
                All Time
            </Label>
            <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{
                    'aria-labelledby': 'demo-customized-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {options.map((item) => {
                    return (
                        <MenuItem onClick={handleClose} disableRipple>
                            {item}
                        </MenuItem>
                    );
                })}

            </StyledMenu>
        </>
    )
}
